import { Agenda } from '@microsoft/mgt-react'
import './NextCommitmentsCard.scss'

const NextCommitmentsCard = () => {
  return (
    <>
      <Agenda groupByDay={true} showMax={4} className="agenda" />
    </>
  )
}

export default NextCommitmentsCard
